/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiOperationTraitDefinition } from '../../models/AaiOperationTraitDefinition';
import { AaiTag } from '../../models/AaiTag';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiOperationTraitDefinition
 * @author eric.wittmann@gmail.com
 */
export class Aai20OperationTraitDefinition extends AaiOperationTraitDefinition {
    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent, name);
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.AaiOperationBase#createTag()
     * @return {AaiTag}
     */
    public createTag() : AaiTag {
        return new Aai20Tag(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Operation#createExternalDocumentation()
     * @return {Aai20ExternalDocumentation}
     */
    public createExternalDocumentation() : Aai20ExternalDocumentation {
        return new Aai20ExternalDocumentation(this);
    }
}
Aai20OperationTraitDefinition["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20OperationTraitDefinition";
Aai20OperationTraitDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.asyncapi.models.IAaiTrait","io.apicurio.datamodels.core.models.common.INamed","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { Aai20ExternalDocumentation } from './Aai20ExternalDocumentation';


import { Aai20Tag } from './Aai20Tag';

